import { render, staticRenderFns } from "./prestations.vue?vue&type=template&id=1c0baf70&scoped=true"
import script from "./prestations.vue?vue&type=script&lang=js"
export * from "./prestations.vue?vue&type=script&lang=js"
import style0 from "./prestations.vue?vue&type=style&index=0&id=1c0baf70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0baf70",
  null
  
)

export default component.exports